import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getInstructorIdDataforInstrucor } from "../../../lib/classview";
import { getDataforInstructorActiveStudent } from "../../../lib/classdetailview";
import { useAuth } from "../../../usercontext";
import GlobalCounselorCorner from "../../pages/common/globalcounselorcorner";

export default function InstructorClassList() {
  const [classlist, setClassList] = useState([]);
  const [studentlist, setStudentList] = useState([]);
  const { profile, setProfile } = useAuth();

  const instructorId = profile.id;

  /*
const handleDelete =  async(id) => {
  const choice = window.confirm(
    'Are You Sure?'
  );
  if (choice) {
    await deleteIdData(id);
    GetData();
    //console.log("Delete",id);
    //router.refresh();
  }
 
};
*/
  async function GetData() {
    const clas = await getInstructorIdDataforInstrucor(instructorId);
    setClassList(clas);
    const student = await getDataforInstructorActiveStudent(instructorId);
    setStudentList(student);
    console.log("student", student);  
    //console.log("class", clas);
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-2">
          <div className="profile-heading p-2">
            <h3>My Classes</h3>
          </div>
          <div className="comman-space pb-0">
            <div className="settings-invoice-blk table-responsive">
              {/* Invoice info */}
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th style={{ width: "30%" }}>Class Name</th>
                    <th style={{ width: "25%" }}>&nbsp;</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {classlist.map(function (data) {
                    return (
                      <tr key={data.id}>
                        <td>
                          <Link to="#" className="invoice-no">
                            {data.id}
                          </Link>
                        </td>
                        <td>{data.class_name}</td>
                        <td className="text-start"> 
                          {studentlist.filter(student => student.classId === data.id)
                          .map(student => (
                            <Link
                              key={student.id}
                              to={`/instructor/instructor-studenttask/${student.studentId}`} 
                              className="badge text-bg-secondary me-3 p-3 rounded-4"
                            >
                              {student.studentName}
                            </Link>
                          ))
                          }
                          </td>
                        <td>
                          <div className="active-change-plan grad-border hvr-sweep-to-right d-flex  justify-content-end">
                            <Link
                              to={`/instructor/instructor-student-grid/${data.id}`}
                              className="btn btn-primary"
                            >
                              More...
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {/* Invoice info */}
            </div>
          </div>
        </div>
      </div>
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          <GlobalCounselorCorner slug={instructorId} isAdmin={false} />
        </div>
      </div>
    </>
  );
}
